import type { ZudokuPlugin } from "zudoku";
import { QueryProvider } from "../providers/QueryProvider";
import { TermlyScript } from "../../components/CookieConsent/TermlyScript";

export const reactQueryPlugin = (): ZudokuPlugin => {
  return {
    getMdxComponents: () => {
      return {
        wrapper: ({ children }: { children: React.ReactNode }) => {
          return (
            <QueryProvider>
              <TermlyScript />
              {children}
            </QueryProvider>
          );
        },
      };
    },
  };
};
